import { useLayoutEffect, useRef, useState } from 'react';
import { flushSync } from 'react-dom';

const useDimensions = () => {
  const gridRef = useRef<HTMLDivElement>(null);
  const [inlineSize, setInlineSize] = useState(1);
  const [blockSize, setBlockSize] = useState(1);
  const [horizontalScrollbarHeight, setHorizontalScrollbarHeight] = useState(0);

  useLayoutEffect(() => {
	const { ResizeObserver } = window;

	// eslint-disable-next-line
	if ( ResizeObserver == null ) return;

	const { clientWidth, clientHeight, offsetWidth, offsetHeight } = gridRef.current!;
	const { width, height } = gridRef.current!.getBoundingClientRect();
	const initialHorizontalScrollbarHeight = offsetHeight - clientHeight;
	const initialWidth = width - offsetWidth + clientWidth;
	const initialHeight = height - initialHorizontalScrollbarHeight;

	setInlineSize(initialWidth);
	setBlockSize(initialHeight);
	setHorizontalScrollbarHeight(initialHorizontalScrollbarHeight);

	const resizeObserver = new ResizeObserver((entries) => {
	  const size = entries[0].contentBoxSize[0];
	  const { clientHeight, offsetHeight } = gridRef.current!;

	  // we use flushSync here to avoid flashing scrollbars
	  flushSync(() => {
		setInlineSize(size.inlineSize);
		setBlockSize(size.blockSize);
		setHorizontalScrollbarHeight(offsetHeight - clientHeight);
	  });
	});
	resizeObserver.observe(gridRef.current!);

	return () => {
	  resizeObserver.disconnect();
	};
  }, []);

  return [gridRef, inlineSize, blockSize, horizontalScrollbarHeight] as const;
};

export default useDimensions;
